const PlayerWindowPositions = {};

PlayerWindowPositions["10_10_buttonLeft"] = 290;
PlayerWindowPositions["10_10_buttonTop"] = 131;
PlayerWindowPositions["10_10_chipsLeft"] = 265;
PlayerWindowPositions["10_10_chipsTop"] = 154;
PlayerWindowPositions["10_10_left"] = 246;
PlayerWindowPositions["10_10_top"] = 12;
PlayerWindowPositions["10_1_buttonLeft"] = 486;
PlayerWindowPositions["10_1_buttonTop"] = 130;
PlayerWindowPositions["10_1_chipsLeft"] = 461;
PlayerWindowPositions["10_1_chipsTop"] = 155;
PlayerWindowPositions["10_1_left"] = 448;
PlayerWindowPositions["10_1_top"] = 11;
PlayerWindowPositions["10_2_buttonLeft"] = 604;
PlayerWindowPositions["10_2_buttonTop"] = 173;
PlayerWindowPositions["10_2_chipsLeft"] = 527;
PlayerWindowPositions["10_2_chipsTop"] = 186;
PlayerWindowPositions["10_2_left"] = 642;
PlayerWindowPositions["10_2_top"] = 84;
PlayerWindowPositions["10_3_buttonLeft"] = 630;
PlayerWindowPositions["10_3_buttonTop"] = 259;
PlayerWindowPositions["10_3_chipsLeft"] = 551;
PlayerWindowPositions["10_3_chipsTop"] = 259;
PlayerWindowPositions["10_3_left"] = 672;
PlayerWindowPositions["10_3_top"] = 212;
PlayerWindowPositions["10_4_buttonLeft"] = 600;
PlayerWindowPositions["10_4_buttonTop"] = 341;
PlayerWindowPositions["10_4_chipsLeft"] = 526;
PlayerWindowPositions["10_4_chipsTop"] = 321;
PlayerWindowPositions["10_4_left"] = 622;
PlayerWindowPositions["10_4_top"] = 349;
PlayerWindowPositions["10_5_buttonLeft"] = 491;
PlayerWindowPositions["10_5_buttonTop"] = 383;
PlayerWindowPositions["10_5_chipsLeft"] = 464;
PlayerWindowPositions["10_5_chipsTop"] = 360;
PlayerWindowPositions["10_5_left"] = 441;
PlayerWindowPositions["10_5_top"] = 402;
PlayerWindowPositions["10_6_buttonLeft"] = 306;
PlayerWindowPositions["10_6_buttonTop"] = 381;
PlayerWindowPositions["10_6_chipsLeft"] = 278;
PlayerWindowPositions["10_6_chipsTop"] = 358;
PlayerWindowPositions["10_6_left"] = 250;
PlayerWindowPositions["10_6_top"] = 402;
PlayerWindowPositions["10_7_buttonLeft"] = 181;
PlayerWindowPositions["10_7_buttonTop"] = 349;
PlayerWindowPositions["10_7_chipsLeft"] = 202;
PlayerWindowPositions["10_7_chipsTop"] = 327;
PlayerWindowPositions["10_7_left"] = 52;
PlayerWindowPositions["10_7_top"] = 357;
PlayerWindowPositions["10_8_buttonLeft"] = 142;
PlayerWindowPositions["10_8_buttonTop"] = 271;
PlayerWindowPositions["10_8_chipsLeft"] = 165;
PlayerWindowPositions["10_8_chipsTop"] = 272;
PlayerWindowPositions["10_8_left"] = 5;
PlayerWindowPositions["10_8_top"] = 216;
PlayerWindowPositions["10_9_buttonLeft"] = 174;
PlayerWindowPositions["10_9_buttonTop"] = 172;
PlayerWindowPositions["10_9_chipsLeft"] = 195;
PlayerWindowPositions["10_9_chipsTop"] = 188;
PlayerWindowPositions["10_9_left"] = 40;
PlayerWindowPositions["10_9_top"] = 88;
PlayerWindowPositions["2_1_buttonLeft"] = 389;
PlayerWindowPositions["2_1_buttonTop"] = 381;
PlayerWindowPositions["2_1_chipsLeft"] = 360;
PlayerWindowPositions["2_1_chipsTop"] = 359;
PlayerWindowPositions["2_1_left"] = 340;
PlayerWindowPositions["2_1_top"] = 404;
PlayerWindowPositions["2_2_buttonLeft"] = 383;
PlayerWindowPositions["2_2_buttonTop"] = 132;
PlayerWindowPositions["2_2_chipsLeft"] = 355;
PlayerWindowPositions["2_2_chipsTop"] = 154;
PlayerWindowPositions["2_2_left"] = 337;
PlayerWindowPositions["2_2_top"] = 23;
PlayerWindowPositions["3_1_buttonLeft"] = 608;
PlayerWindowPositions["3_1_buttonTop"] = 189;
PlayerWindowPositions["3_1_chipsLeft"] = 527;
PlayerWindowPositions["3_1_chipsTop"] = 190;
PlayerWindowPositions["3_1_left"] = 659;
PlayerWindowPositions["3_1_top"] = 112;
PlayerWindowPositions["3_2_buttonLeft"] = 397;
PlayerWindowPositions["3_2_buttonTop"] = 379;
PlayerWindowPositions["3_2_chipsLeft"] = 368;
PlayerWindowPositions["3_2_chipsTop"] = 353;
PlayerWindowPositions["3_2_left"] = 335;
PlayerWindowPositions["3_2_top"] = 403;
PlayerWindowPositions["3_3_buttonLeft"] = 163;
PlayerWindowPositions["3_3_buttonTop"] = 191;
PlayerWindowPositions["3_3_chipsLeft"] = 186;
PlayerWindowPositions["3_3_chipsTop"] = 191;
PlayerWindowPositions["3_3_left"] = 16;
PlayerWindowPositions["3_3_top"] = 110;
PlayerWindowPositions["4_1_buttonLeft"] = 631;
PlayerWindowPositions["4_1_buttonTop"] = 255;
PlayerWindowPositions["4_1_chipsLeft"] = 551;
PlayerWindowPositions["4_1_chipsTop"] = 255;
PlayerWindowPositions["4_1_left"] = 679;
PlayerWindowPositions["4_1_top"] = 202;
PlayerWindowPositions["4_2_buttonLeft"] = 386;
PlayerWindowPositions["4_2_buttonTop"] = 378;
PlayerWindowPositions["4_2_chipsLeft"] = 355;
PlayerWindowPositions["4_2_chipsTop"] = 354;
PlayerWindowPositions["4_2_left"] = 337;
PlayerWindowPositions["4_2_top"] = 420;
PlayerWindowPositions["4_3_buttonLeft"] = 144;
PlayerWindowPositions["4_3_buttonTop"] = 256;
PlayerWindowPositions["4_3_chipsLeft"] = 169;
PlayerWindowPositions["4_3_chipsTop"] = 255;
PlayerWindowPositions["4_3_left"] = 1;
PlayerWindowPositions["4_3_top"] = 204;
PlayerWindowPositions["4_4_buttonLeft"] = 382;
PlayerWindowPositions["4_4_buttonTop"] = 134;
PlayerWindowPositions["4_4_chipsLeft"] = 351;
PlayerWindowPositions["4_4_chipsTop"] = 157;
PlayerWindowPositions["4_4_left"] = 335;
PlayerWindowPositions["4_4_top"] = 26;
PlayerWindowPositions["5_1_buttonLeft"] = 490;
PlayerWindowPositions["5_1_buttonTop"] = 131;
PlayerWindowPositions["5_1_chipsLeft"] = 465;
PlayerWindowPositions["5_1_chipsTop"] = 153;
PlayerWindowPositions["5_1_left"] = 443;
PlayerWindowPositions["5_1_top"] = 25;
PlayerWindowPositions["5_2_buttonLeft"] = 631;
PlayerWindowPositions["5_2_buttonTop"] = 256;
PlayerWindowPositions["5_2_chipsLeft"] = 550;
PlayerWindowPositions["5_2_chipsTop"] = 256;
PlayerWindowPositions["5_2_left"] = 675;
PlayerWindowPositions["5_2_top"] = 202;
PlayerWindowPositions["5_3_buttonLeft"] = 392;
PlayerWindowPositions["5_3_buttonTop"] = 379;
PlayerWindowPositions["5_3_chipsLeft"] = 363;
PlayerWindowPositions["5_3_chipsTop"] = 357;
PlayerWindowPositions["5_3_left"] = 345;
PlayerWindowPositions["5_3_top"] = 418;
PlayerWindowPositions["5_4_buttonLeft"] = 142;
PlayerWindowPositions["5_4_buttonTop"] = 255;
PlayerWindowPositions["5_4_chipsLeft"] = 165;
PlayerWindowPositions["5_4_chipsTop"] = 256;
PlayerWindowPositions["5_4_left"] = 2;
PlayerWindowPositions["5_4_top"] = 202;
PlayerWindowPositions["5_5_buttonLeft"] = 262;
PlayerWindowPositions["5_5_buttonTop"] = 131;
PlayerWindowPositions["5_5_chipsLeft"] = 234;
PlayerWindowPositions["5_5_chipsTop"] = 153;
PlayerWindowPositions["5_5_left"] = 221;
PlayerWindowPositions["5_5_top"] = 24;
PlayerWindowPositions["6_1_buttonLeft"] = 605;
PlayerWindowPositions["6_1_buttonTop"] = 180;
PlayerWindowPositions["6_1_chipsLeft"] = 525;
PlayerWindowPositions["6_1_chipsTop"] = 179;
PlayerWindowPositions["6_1_left"] = 662;
PlayerWindowPositions["6_1_top"] = 89;
PlayerWindowPositions["6_2_buttonLeft"] = 599;
PlayerWindowPositions["6_2_buttonTop"] = 339;
PlayerWindowPositions["6_2_chipsLeft"] = 519;
PlayerWindowPositions["6_2_chipsTop"] = 339;
PlayerWindowPositions["6_2_left"] = 659;
PlayerWindowPositions["6_2_top"] = 315;
PlayerWindowPositions["6_3_buttonLeft"] = 393;
PlayerWindowPositions["6_3_buttonTop"] = 381;
PlayerWindowPositions["6_3_chipsLeft"] = 370;
PlayerWindowPositions["6_3_chipsTop"] = 356;
PlayerWindowPositions["6_3_left"] = 337;
PlayerWindowPositions["6_3_top"] = 384;
PlayerWindowPositions["6_4_buttonLeft"] = 177;
PlayerWindowPositions["6_4_buttonTop"] = 340;
PlayerWindowPositions["6_4_chipsLeft"] = 201;
PlayerWindowPositions["6_4_chipsTop"] = 340;
PlayerWindowPositions["6_4_left"] = 18;
PlayerWindowPositions["6_4_top"] = 313;
PlayerWindowPositions["6_5_buttonLeft"] = 168;
PlayerWindowPositions["6_5_buttonTop"] = 184;
PlayerWindowPositions["6_5_chipsLeft"] = 191;
PlayerWindowPositions["6_5_chipsTop"] = 184;
PlayerWindowPositions["6_5_left"] = 19;
PlayerWindowPositions["6_5_top"] = 101;
PlayerWindowPositions["6_6_buttonLeft"] = 387;
PlayerWindowPositions["6_6_buttonTop"] = 130;
PlayerWindowPositions["6_6_chipsLeft"] = 358;
PlayerWindowPositions["6_6_chipsTop"] = 152;
PlayerWindowPositions["6_6_left"] = 341;
PlayerWindowPositions["6_6_top"] = 2;
PlayerWindowPositions["7_1_buttonLeft"] = 498;
PlayerWindowPositions["7_1_buttonTop"] = 131;
PlayerWindowPositions["7_1_chipsLeft"] = 469;
PlayerWindowPositions["7_1_chipsTop"] = 153;
PlayerWindowPositions["7_1_left"] = 447;
PlayerWindowPositions["7_1_top"] = -3;
PlayerWindowPositions["7_2_buttonLeft"] = 615;
PlayerWindowPositions["7_2_buttonTop"] = 201;
PlayerWindowPositions["7_2_chipsLeft"] = 540;
PlayerWindowPositions["7_2_chipsTop"] = 199;
PlayerWindowPositions["7_2_left"] = 681;
PlayerWindowPositions["7_2_top"] = 129;
PlayerWindowPositions["7_3_buttonLeft"] = 610;
PlayerWindowPositions["7_3_buttonTop"] = 323;
PlayerWindowPositions["7_3_chipsLeft"] = 531;
PlayerWindowPositions["7_3_chipsTop"] = 322;
PlayerWindowPositions["7_3_left"] = 682;
PlayerWindowPositions["7_3_top"] = 272;
PlayerWindowPositions["7_4_buttonLeft"] = 379;
PlayerWindowPositions["7_4_buttonTop"] = 379;
PlayerWindowPositions["7_4_chipsLeft"] = 358;
PlayerWindowPositions["7_4_chipsTop"] = 353;
PlayerWindowPositions["7_4_left"] = 336;
PlayerWindowPositions["7_4_top"] = 409;
PlayerWindowPositions["7_5_buttonLeft"] = 166;
PlayerWindowPositions["7_5_buttonTop"] = 328;
PlayerWindowPositions["7_5_chipsLeft"] = 190;
PlayerWindowPositions["7_5_chipsTop"] = 328;
PlayerWindowPositions["7_5_left"] = 7;
PlayerWindowPositions["7_5_top"] = 269;
PlayerWindowPositions["7_6_buttonLeft"] = 154;
PlayerWindowPositions["7_6_buttonTop"] = 203;
PlayerWindowPositions["7_6_chipsLeft"] = 176;
PlayerWindowPositions["7_6_chipsTop"] = 203;
PlayerWindowPositions["7_6_left"] = 6;
PlayerWindowPositions["7_6_top"] = 128;
PlayerWindowPositions["7_7_buttonLeft"] = 293;
PlayerWindowPositions["7_7_buttonTop"] = 132;
PlayerWindowPositions["7_7_chipsLeft"] = 267;
PlayerWindowPositions["7_7_chipsTop"] = 155;
PlayerWindowPositions["7_7_left"] = 236;
PlayerWindowPositions["7_7_top"] = -3;
PlayerWindowPositions["8_1_buttonLeft"] = 569;
PlayerWindowPositions["8_1_buttonTop"] = 143;
PlayerWindowPositions["8_1_chipsLeft"] = 493;
PlayerWindowPositions["8_1_chipsTop"] = 157;
PlayerWindowPositions["8_1_left"] = 587;
PlayerWindowPositions["8_1_top"] = 39;
PlayerWindowPositions["8_2_buttonLeft"] = 631;
PlayerWindowPositions["8_2_buttonTop"] = 250;
PlayerWindowPositions["8_2_chipsLeft"] = 552;
PlayerWindowPositions["8_2_chipsTop"] = 250;
PlayerWindowPositions["8_2_left"] = 675;
PlayerWindowPositions["8_2_top"] = 193;
PlayerWindowPositions["8_3_buttonLeft"] = 577;
PlayerWindowPositions["8_3_buttonTop"] = 358;
PlayerWindowPositions["8_3_chipsLeft"] = 496;
PlayerWindowPositions["8_3_chipsTop"] = 356;
PlayerWindowPositions["8_3_left"] = 584;
PlayerWindowPositions["8_3_top"] = 362;
PlayerWindowPositions["8_4_buttonLeft"] = 396;
PlayerWindowPositions["8_4_buttonTop"] = 380;
PlayerWindowPositions["8_4_chipsLeft"] = 355;
PlayerWindowPositions["8_4_chipsTop"] = 358;
PlayerWindowPositions["8_4_left"] = 335;
PlayerWindowPositions["8_4_top"] = 408;
PlayerWindowPositions["8_5_buttonLeft"] = 205;
PlayerWindowPositions["8_5_buttonTop"] = 363;
PlayerWindowPositions["8_5_chipsLeft"] = 227;
PlayerWindowPositions["8_5_chipsTop"] = 359;
PlayerWindowPositions["8_5_left"] = 94;
PlayerWindowPositions["8_5_top"] = 362;
PlayerWindowPositions["8_6_buttonLeft"] = 142;
PlayerWindowPositions["8_6_buttonTop"] = 252;
PlayerWindowPositions["8_6_chipsLeft"] = 164;
PlayerWindowPositions["8_6_chipsTop"] = 250;
PlayerWindowPositions["8_6_left"] = 0;
PlayerWindowPositions["8_6_top"] = 194;
PlayerWindowPositions["8_7_buttonLeft"] = 210;
PlayerWindowPositions["8_7_buttonTop"] = 146;
PlayerWindowPositions["8_7_chipsLeft"] = 231;
PlayerWindowPositions["8_7_chipsTop"] = 158;
PlayerWindowPositions["8_7_left"] = 91;
PlayerWindowPositions["8_7_top"] = 41;
PlayerWindowPositions["8_8_buttonLeft"] = 399;
PlayerWindowPositions["8_8_buttonTop"] = 133;
PlayerWindowPositions["8_8_chipsLeft"] = 384;
PlayerWindowPositions["8_8_chipsTop"] = 155;
PlayerWindowPositions["8_8_left"] = 358;
PlayerWindowPositions["8_8_top"] = 19;
PlayerWindowPositions["9_1_buttonLeft"] = 488;
PlayerWindowPositions["9_1_buttonTop"] = 133;
PlayerWindowPositions["9_1_chipsLeft"] = 460;
PlayerWindowPositions["9_1_chipsTop"] = 155;
PlayerWindowPositions["9_1_left"] = 443;
PlayerWindowPositions["9_1_top"] = 22;
PlayerWindowPositions["9_2_buttonLeft"] = 612;
PlayerWindowPositions["9_2_buttonTop"] = 186;
PlayerWindowPositions["9_2_chipsLeft"] = 534;
PlayerWindowPositions["9_2_chipsTop"] = 204;
PlayerWindowPositions["9_2_left"] = 654;
PlayerWindowPositions["9_2_top"] = 103;
PlayerWindowPositions["9_3_buttonLeft"] = 612;
PlayerWindowPositions["9_3_buttonTop"] = 326;
PlayerWindowPositions["9_3_chipsLeft"] = 533;
PlayerWindowPositions["9_3_chipsTop"] = 317;
PlayerWindowPositions["9_3_left"] = 663;
PlayerWindowPositions["9_3_top"] = 298;
PlayerWindowPositions["9_4_buttonLeft"] = 535;
PlayerWindowPositions["9_4_buttonTop"] = 376;
PlayerWindowPositions["9_4_chipsLeft"] = 493;
PlayerWindowPositions["9_4_chipsTop"] = 353;
PlayerWindowPositions["9_4_left"] = 511;
PlayerWindowPositions["9_4_top"] = 403;
PlayerWindowPositions["9_5_buttonLeft"] = 390;
PlayerWindowPositions["9_5_buttonTop"] = 381;
PlayerWindowPositions["9_5_chipsLeft"] = 365;
PlayerWindowPositions["9_5_chipsTop"] = 354;
PlayerWindowPositions["9_5_left"] = 342;
PlayerWindowPositions["9_5_top"] = 404;
PlayerWindowPositions["9_6_buttonLeft"] = 247;
PlayerWindowPositions["9_6_buttonTop"] = 380;
PlayerWindowPositions["9_6_chipsLeft"] = 233;
PlayerWindowPositions["9_6_chipsTop"] = 356;
PlayerWindowPositions["9_6_left"] = 176;
PlayerWindowPositions["9_6_top"] = 404;
PlayerWindowPositions["9_7_buttonLeft"] = 162;
PlayerWindowPositions["9_7_buttonTop"] = 323;
PlayerWindowPositions["9_7_chipsLeft"] = 186;
PlayerWindowPositions["9_7_chipsTop"] = 315;
PlayerWindowPositions["9_7_left"] = 22;
PlayerWindowPositions["9_7_top"] = 304;
PlayerWindowPositions["9_8_buttonLeft"] = 158;
PlayerWindowPositions["9_8_buttonTop"] = 195;
PlayerWindowPositions["9_8_chipsLeft"] = 181;
PlayerWindowPositions["9_8_chipsTop"] = 215;
PlayerWindowPositions["9_8_left"] = 21;
PlayerWindowPositions["9_8_top"] = 105;
PlayerWindowPositions["9_9_buttonLeft"] = 276;
PlayerWindowPositions["9_9_buttonTop"] = 133;
PlayerWindowPositions["9_9_chipsLeft"] = 248;
PlayerWindowPositions["9_9_chipsTop"] = 155;
PlayerWindowPositions["9_9_left"] = 234;
PlayerWindowPositions["9_9_top"] = 22;


export default PlayerWindowPositions;
